/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink } from "react-router-dom";
import cx from "classnames";

import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";

import ExitToApp from "@material-ui/icons/ExitToApp";
import PersonAdd from "@material-ui/icons/PersonAdd";

import { hasAnyRole, getUserRoles } from "auth/roles";
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.js";

var ps;

// --- Guest helpers ---
const isGuestUser = () => localStorage.getItem("guestMode") === "true";

class SidebarWrapper extends React.Component {
    sidebarWrapper = React.createRef();

    componentDidMount() {
        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(this.sidebarWrapper.current, {
                suppressScrollX: true,
                suppressScrollY: false
            });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1 && ps) {
            ps.destroy();
        }
    }

    render() {
        const { className, user, headerLinks, links } = this.props;
        return (
            <div className={className} ref={this.sidebarWrapper}>
                {user}
                {headerLinks}
                {links}
            </div>
        );
    }
}

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openAvatar: false,
            miniActive: true,
            ...this.getCollapseStates(props.routes)
        };
    }

    mainPanel = React.createRef();

    userHasAccess = (route) => {
        const guest = isGuestUser();

        // Versteckte Routen nie in Sidebar anzeigen
        if (route.invisible || route.hidden) {
            return false;
        }

        // Gast darf nur explizit erlaubte Routen sehen
        if (guest) {
            return route.guestAllowed === true;
        }

        const userRoles = getUserRoles();

        // Keine Rollen definiert -> �ffentlich f�r normale eingeloggte User
        if (!route.roles || route.roles.length === 0) {
            return true;
        }

        return hasAnyRole(userRoles, route.roles);
    };

    getCollapseStates = routes => {
        let initialState = {};
        routes.map(prop => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: this.getCollapseInitialState(prop.views),
                    ...this.getCollapseStates(prop.views),
                    ...initialState
                };
            }
            return null;
        });
        return initialState;
    };

    getCollapseInitialState(routes) {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
                return true;
            } else if (window.location.href.indexOf(routes[i].path) !== -1) {
                return true;
            }
        }
        return false;
    }

    activeRoute = routeName => {
        return window.location.href.indexOf(routeName) > -1 ? "active" : "";
    };

    openCollapse(collapse) {
        var st = {};
        st[collapse] = !this.state[collapse];
        this.setState(st);
    }

    handleLogout = async () => {
        const guest = isGuestUser();

        if (!guest) {
            const refreshToken = localStorage.getItem("refreshToken");
            const accessToken = localStorage.getItem("accessToken");

            if (refreshToken && accessToken && window.authfetch) {
                try {
                    await window.authfetch("/api/auth/logout", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${accessToken}`
                        },
                        body: JSON.stringify({ refreshToken })
                    });
                } catch { }
            }
        }

        localStorage.clear();
        document.body.classList.remove("app-watermark");
        window.location.href = "/login";
    };

    createLinks = routes => {
        const { classes, color, rtlActive } = this.props;

        return routes
            .filter((prop) => {
                if (prop.redirect) return false;
                if (prop.invisible || prop.hidden) return false;

                if (prop.collapse && prop.views) {
                    return prop.views.some((v) => this.userHasAccess(v));
                }

                return this.userHasAccess(prop);
            })
            .map((prop, key) => {
                if (prop.collapse) {
                    var st = {};
                    st[prop["state"]] = !this.state[prop.state];

                    const navLinkClasses =
                        classes.itemLink +
                        " " +
                        cx({
                            [" " + classes.collapseActive]: this.getCollapseInitialState(prop.views)
                        });

                    const itemText =
                        classes.itemText +
                        " " +
                        cx({
                            [classes.itemTextMini]:
                                this.props.miniActive && this.state.miniActive,
                            [classes.itemTextMiniRTL]:
                                rtlActive && this.props.miniActive && this.state.miniActive,
                            [classes.itemTextRTL]: rtlActive
                        });

                    const collapseItemText =
                        classes.collapseItemText +
                        " " +
                        cx({
                            [classes.collapseItemTextMini]:
                                this.props.miniActive && this.state.miniActive,
                            [classes.collapseItemTextMiniRTL]:
                                rtlActive && this.props.miniActive && this.state.miniActive,
                            [classes.collapseItemTextRTL]: rtlActive
                        });

                    const itemIcon =
                        classes.itemIcon +
                        " " +
                        cx({
                            [classes.itemIconRTL]: rtlActive
                        });

                    const caret =
                        classes.caret +
                        " " +
                        cx({
                            [classes.caretRTL]: rtlActive
                        });

                    const collapseItemMini =
                        classes.collapseItemMini +
                        " " +
                        cx({
                            [classes.collapseItemMiniRTL]: rtlActive
                        });

                    return (
                        <ListItem
                            key={key}
                            className={cx(
                                { [classes.item]: prop.icon !== undefined },
                                { [classes.collapseItem]: prop.icon === undefined }
                            )}
                        >
                            <NavLink
                                to={"#"}
                                className={navLinkClasses}
                                onClick={e => {
                                    e.preventDefault();
                                    this.setState(st);
                                }}
                            >
                                {prop.icon !== undefined ? (
                                    typeof prop.icon === "string" ? (
                                        <Icon className={itemIcon}>{prop.icon}</Icon>
                                    ) : (
                                        <prop.icon className={itemIcon} />
                                    )
                                ) : (
                                    <span className={collapseItemMini}>
                                        {rtlActive ? prop.rtlMini : prop.mini}
                                    </span>
                                )}
                                <ListItemText
                                    primary={rtlActive ? prop.rtlName : prop.name}
                                    secondary={
                                        <b
                                            className={
                                                caret +
                                                " " +
                                                (this.state[prop.state] ? classes.caretActive : "")
                                            }
                                        />
                                    }
                                    disableTypography={true}
                                    className={cx(
                                        { [itemText]: prop.icon !== undefined },
                                        { [collapseItemText]: prop.icon === undefined }
                                    )}
                                />
                            </NavLink>
                            <Collapse in={this.state[prop.state]} unmountOnExit>
                                <List className={classes.list + " " + classes.collapseList}>
                                    {this.createLinks(prop.views)}
                                </List>
                            </Collapse>
                        </ListItem>
                    );
                }

                const innerNavLinkClasses =
                    classes.collapseItemLink +
                    " " +
                    cx({
                        [" " + classes[color]]: this.activeRoute(prop.path)
                    });

                const collapseItemMini =
                    classes.collapseItemMini +
                    " " +
                    cx({
                        [classes.collapseItemMiniRTL]: rtlActive
                    });

                const navLinkClasses =
                    classes.itemLink +
                    " " +
                    cx({
                        [" " + classes[color]]: this.activeRoute(prop.path)
                    });

                const itemText =
                    classes.itemText +
                    " " +
                    cx({
                        [classes.itemTextMini]:
                            this.props.miniActive && this.state.miniActive,
                        [classes.itemTextMiniRTL]:
                            rtlActive && this.props.miniActive && this.state.miniActive,
                        [classes.itemTextRTL]: rtlActive
                    });

                const collapseItemText =
                    classes.collapseItemText +
                    " " +
                    cx({
                        [classes.collapseItemTextMini]:
                            this.props.miniActive && this.state.miniActive,
                        [classes.collapseItemTextMiniRTL]:
                            rtlActive && this.props.miniActive && this.state.miniActive,
                        [classes.collapseItemTextRTL]: rtlActive
                    });

                const itemIcon =
                    classes.itemIcon +
                    " " +
                    cx({
                        [classes.itemIconRTL]: rtlActive
                    });

                return (
                    <ListItem
                        key={key}
                        className={cx(
                            { [classes.item]: prop.icon !== undefined },
                            { [classes.collapseItem]: prop.icon === undefined }
                        )}
                    >
                        <NavLink
                            to={prop.layout + prop.path}
                            className={cx(
                                { [navLinkClasses]: prop.icon !== undefined },
                                { [innerNavLinkClasses]: prop.icon === undefined }
                            )}
                        >
                            {prop.icon !== undefined ? (
                                typeof prop.icon === "string" ? (
                                    <Icon className={itemIcon}>{prop.icon}</Icon>
                                ) : (
                                    <prop.icon className={itemIcon} />
                                )
                            ) : (
                                <span className={collapseItemMini}>
                                    {rtlActive ? prop.rtlMini : prop.mini}
                                </span>
                            )}
                            <ListItemText
                                primary={rtlActive ? prop.rtlName : prop.name}
                                disableTypography={true}
                                className={cx(
                                    { [itemText]: prop.icon !== undefined },
                                    { [collapseItemText]: prop.icon === undefined }
                                )}
                            />
                        </NavLink>
                    </ListItem>
                );
            });
    };

    render() {
        const {
            classes,
            image,
            logoText,
            routes,
            bgColor,
            rtlActive
        } = this.props;

        const guest = isGuestUser();
        const username = localStorage.getItem("username");

        const user = "";

        const links = (
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <List className={classes.list} style={{ flex: 1 }}>
                    {this.createLinks(routes)}
                </List>

                {guest && (
                    <ListItem
                        className={classes.item}
                        button
                        component={NavLink}
                        to="/register"
                    >
                        <PersonAdd className={classes.itemIcon} />
                        <ListItemText
                            primary="Registrieren"
                            className={classes.itemText}
                        />
                    </ListItem>
                )}

                <ListItem
                    className={classes.item}
                    button
                    onClick={this.handleLogout}
                >
                    <ExitToApp className={classes.itemIcon} />
                    <ListItemText
                        primary={guest ? "Logout Gast" : "Logout Benutzer " + (username || "")}
                        className={classes.itemText}
                    />
                </ListItem>
            </div>
        );

        const logoNormal =
            classes.logoNormal +
            " " +
            cx({
                [classes.logoNormalSidebarMini]:
                    this.props.miniActive && this.state.miniActive,
                [classes.logoNormalSidebarMiniRTL]:
                    rtlActive && this.props.miniActive && this.state.miniActive,
                [classes.logoNormalRTL]: rtlActive
            });

        const logoMini =
            classes.logoMini +
            " " +
            cx({
                [classes.logoMiniRTL]: rtlActive
            });

        const logoClasses =
            classes.logo +
            " " +
            cx({
                [classes.whiteAfter]: bgColor === "white"
            });

        const brand = (
            <div className={logoClasses}>
                <a href="/" className={logoMini}></a>
                <a href="/" className={logoNormal}>
                    {logoText}
                </a>
            </div>
        );

        const drawerPaper =
            classes.drawerPaper +
            " " +
            cx({
                [classes.drawerPaperMini]:
                    this.props.miniActive && this.state.miniActive,
                [classes.drawerPaperRTL]: rtlActive
            });

        const sidebarWrapper =
            classes.sidebarWrapper +
            " " +
            cx({
                [classes.drawerPaperMini]:
                    this.props.miniActive && this.state.miniActive,
                [classes.sidebarWrapperWithPerfectScrollbar]:
                    navigator.platform.indexOf("Win") > -1
            });

        return (
            <div ref={this.mainPanel}>
                <Hidden mdUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={rtlActive ? "left" : "right"}
                        open={this.props.open}
                        classes={{
                            paper: drawerPaper + " " + classes[bgColor + "Background"]
                        }}
                        onClose={this.props.handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true
                        }}
                    >
                        {brand}
                        <SidebarWrapper
                            className={sidebarWrapper}
                            user={user}
                            headerLinks={<AdminNavbarLinks rtlActive={rtlActive} />}
                            links={links}
                        />
                        {image !== undefined ? (
                            <div
                                className={classes.background}
                                style={{ backgroundImage: "url(" + image + ")" }}
                            />
                        ) : null}
                    </Drawer>
                </Hidden>

                <Hidden smDown implementation="css">
                    <Drawer
                        onMouseOver={() => this.setState({ miniActive: false })}
                        onMouseOut={() => this.setState({ miniActive: true })}
                        anchor={rtlActive ? "right" : "left"}
                        variant={window.innerWidth < 960 ? "temporary" : "permanent"}
                        open
                        classes={{
                            paper: drawerPaper + " " + classes[bgColor + "Background"]
                        }}
                    >
                        {brand}
                        <SidebarWrapper
                            className={sidebarWrapper}
                            user={user}
                            links={links}
                        />
                        {image !== undefined ? (
                            <div
                                className={classes.background}
                                style={{ backgroundImage: "url(" + image + ")" }}
                            />
                        ) : null}
                    </Drawer>
                </Hidden>
            </div>
        );
    }
}

Sidebar.defaultProps = {
    bgColor: "blue"
};

Sidebar.propTypes = {
    classes: PropTypes.object.isRequired,
    bgColor: PropTypes.oneOf(["white", "black", "blue"]),
    rtlActive: PropTypes.bool,
    color: PropTypes.oneOf([
        "white",
        "red",
        "orange",
        "green",
        "blue",
        "purple",
        "rose"
    ]),
    logo: PropTypes.string,
    logoText: PropTypes.string,
    image: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    miniActive: PropTypes.bool,
    open: PropTypes.bool,
    handleDrawerToggle: PropTypes.func
};

SidebarWrapper.propTypes = {
    className: PropTypes.string,
    user: PropTypes.object,
    headerLinks: PropTypes.object,
    links: PropTypes.object
};

export default withStyles(sidebarStyle)(Sidebar);